import { Button } from "@mantine/core"
import { primaryColor } from "../../../../constants/theme"
import { IconCreditCard } from "@tabler/icons-react"
import { useNavigate } from "react-router-dom";

export const PaymentsButton = ({width}: {width?: number}) => {

    const navigate = useNavigate();

    const handleClick = () => {
      navigate('/payment-history');
    };

    return (
        <Button w={width} variant="outline" color={primaryColor} leftSection={<IconCreditCard size={20} />} onClick={handleClick}>
            Payments
        </Button>
    );

}


